import React from 'react';
import withStyles from 'react-jss';

const styles = {
  topBar: {
    gridColumn: '1/3',
    display: 'grid',
    gridTemplateColumns: 'auto 100px ',
  },
  buttons: {
    textAlign: 'right',
    '& > *': {
      marginLeft: 5,
    },
  },
  address: {
    whiteSpace: 'pre-wrap',
  },
};

const User = ({ classes, user }) => {
  return (
    <div>
      <div className={classes.topBar}>
        <h1>User: {user.name}</h1>
      </div>
      <div>
        <a href={'mailto:' + user.email}>{user.email}</a>
        <div>{user.active ? '' : 'Ikke aktivert'}</div>
      </div>
    </div>
  );
};

export default withStyles(styles)(User);
